import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("progress", {
  class: "progress is-small is-info my-6",
  max: "100"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseGridCell = _resolveComponent("BaseGridCell")!
  const _component_BaseGridRow = _resolveComponent("BaseGridRow")!
  const _component_BaseGridContainer = _resolveComponent("BaseGridContainer")!

  return (_openBlock(), _createBlock(_component_BaseGridContainer, { class: "px-6" }, {
    default: _withCtx(() => [
      _createVNode(_component_BaseGridRow, {
        isCentered: "",
        isMobile: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BaseGridCell, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}